export const normalizePhone = (value) => value.replace(/\D+/g, '');



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/utils.js